var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsMultiSelectPartnerUserService, List, ListUser } from './multiselect-partner-user.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
import { AddRowDirective } from '../../../../component/addrow/addrow.directive';
var KtsMultiSelectPartnerUserComponent = /** @class */ (function (_super) {
    __extends(KtsMultiSelectPartnerUserComponent, _super);
    function KtsMultiSelectPartnerUserComponent(router, route, logger, action, message, page, service, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.modalSubmit = new EventEmitter();
        _this.recs = [];
        _this.items = [];
        _this.select = [];
        _this.addRec = {};
        _this.readonly = false;
        _this.excludeHq = false;
        _this.constClassId = 0;
        _this.constClass = [];
        _this.constMiddleClassId = 0;
        _this.constMiddleClass = {};
        _this.companyName = '';
        _this.retirees = [];
        _this.areaId = 0;
        _this.area = [];
        _this.targetIds = [];
        _this.targetUserIds = [];
        _this.showUsers = [];
        _this.selectedUsers = [];
        _this.userItems = [];
        _this.service.init();
        return _this;
    }
    KtsMultiSelectPartnerUserComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.excludeHq = jsonpath.value(this.component, '$.params.excludeHq') || false;
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError();
            }
        });
        if (this.cols.length > 0) {
            if (!this.cols[0].readonly) {
                this.getType();
                this.getList();
                this.getRetiree();
            }
            if (this.cols[0].readonly) {
                this.readonly = true;
            }
            if (this.cols[0].items) {
                this.getAddCols(this.cols[0].items);
            }
        }
        this.setCompRec();
    };
    KtsMultiSelectPartnerUserComponent.prototype.getType = function () {
        var _this = this;
        this.service.setBaseUrl('/v1/gen/construction-classification-m-api?query={"orderByList":[{"name":"id","direction":"asc"}]}');
        this.service.getRecord().subscribe(function (rec) {
            var constClass = [];
            var constMiddleClass = {};
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                constClass.push({ code: item.id, display: item.name });
                var options = [];
                _this.service.sortItems(item.construction_middle_classification, 'id');
                for (var _b = 0, _c = item.construction_middle_classification; _b < _c.length; _b++) {
                    var middleItem = _c[_b];
                    options.push({ code: middleItem.id, display: middleItem.name });
                }
                constMiddleClass[item.id] = options;
            }
            _this.constClass = constClass;
            _this.constMiddleClass = constMiddleClass;
        });
        this.service.getType('PARTNER_COMPANY_AREA').subscribe(function (rec) { return _this.area = rec; });
    };
    KtsMultiSelectPartnerUserComponent.prototype.getList = function () {
        var _this = this;
        this.recs = [];
        var url = '/v1/gen/partner-company-m-service';
        if (this.excludeHq) {
            url += '?query={"predicateList":[{"name":"unit_m.name","value":"hq","operator":"ne"}],"orderByList":[{"name":"id","direction":"asc"}]}';
        }
        else {
            url += '?query={"orderByList":[{"name":"id","direction":"asc"}]}';
        }
        this.service.setBaseUrl(url);
        this.service.getRecord().subscribe(function (rec) {
            _this.recs = rec.items || [];
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.getAddCols = function (cols) {
        this.addRec = {};
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.hidden && col.key && col.params && typeof col.params.initValue !== 'undefined') {
                this.addRec[col.key] = col.params.initValue;
            }
        }
    };
    KtsMultiSelectPartnerUserComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.modal = this.remodalElement.nativeElement;
        this.remodal = $(this.modal).remodal({ hashTracking: false });
        var self = this;
        this.element = this.multiSelectElement.nativeElement;
        this.select = [];
        $(this.element).multiSelect({
            afterInit: function (ms) {
                var selectableSearchString = '#' + this.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                $(selectableSearchString).hide();
                if (self.constClassId || self.constMiddleClassId || self.areaId || self.companyName) {
                    for (var _i = 0, _a = self.targetIds; _i < _a.length; _i++) {
                        var target = _a[_i];
                        $(selectableSearchString + '[data-id="' + target + '"]').show();
                    }
                }
                else {
                    $(selectableSearchString).show();
                }
            },
            afterSelect: function (values) {
                if (values && values[0]) {
                    self.select.push(values[0]);
                }
            },
            afterDeselect: function (values) {
                if (values && values[0]) {
                    var idx = self.select.indexOf(values[0]);
                    if (idx >= 0) {
                        self.select.splice(idx, 1);
                    }
                }
                $(self.element).multiSelect('refresh');
            }
        });
        this.multiSelectOptions.changes.subscribe(function (t) {
            $(_this.element).multiSelect('refresh');
        });
        this.modalUser = this.remodalUserElement.nativeElement;
        this.remodalUser = $(this.modalUser).remodal({ hashTracking: false });
        this.elementUser = this.multiSelectElementUser.nativeElement;
        $(this.elementUser).multiSelect({
            afterInit: function (ms) {
                var selectableSearchString = '#' + this.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';
                $(selectableSearchString).hide();
                for (var _i = 0, _a = self.targetUserIds; _i < _a.length; _i++) {
                    var target = _a[_i];
                    if (self.retirees.indexOf(target) < 0) {
                        $(selectableSearchString + '[data-id="' + target + '"]').show();
                    }
                }
            },
            afterSelect: function (values) {
                if (values && values[0] && self.selectedUsers.indexOf(values[0]) < 0) {
                    self.selectedUsers.push(values[0]);
                }
            },
            afterDeselect: function (values) {
                if (values && values[0]) {
                    var idx = self.selectedUsers.indexOf(values[0]);
                    if (idx >= 0) {
                        self.selectedUsers.splice(idx, 1);
                    }
                }
                $(self.elementUser).multiSelect('refresh');
            }
        });
        this.multiSelectOptionsUser.changes.subscribe(function (t) {
            $(_this.elementUser).multiSelect('refresh');
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsMultiSelectPartnerUserComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        this.select = [];
        this.selectedUsers = [];
        this.userItems = [];
        if (typeof data[this.cols[0].key] !== 'undefined' && data[this.cols[0].key] instanceof Array && data[this.cols[0].key].length > 0) {
            if (typeof data[this.cols[0].key][0].au_m_xuid === 'undefined') {
                this.select = [];
                this.items = [];
                var itemsTemp = JSOG.parse(JSON.stringify(data[this.cols[0].key]));
                for (var _i = 0, itemsTemp_1 = itemsTemp; _i < itemsTemp_1.length; _i++) {
                    var item = itemsTemp_1[_i];
                    this.select.push(item.partner_company_m_id.toString());
                    this.items.push({
                        $type: (typeof item.id !== 'undefined' ? "put" /* Put */ : "post" /* Post */),
                        id: item.id,
                        partner_company_m_id: item.partner_company_m_id,
                        partner_company_name: item.partner_company_name,
                        count_allowed: 0,
                        count_not_allowed: 0,
                        unit_m_id: item.unit_m_id
                    });
                }
                return;
            }
            else {
                this.userItems = JSOG.parse(JSON.stringify(data[this.cols[0].key]));
            }
        }
        for (var _a = 0, _b = this.userItems; _a < _b.length; _a++) {
            var item = _b[_a];
            if (typeof item.id !== 'undefined') {
                item.$type = "put" /* Put */;
            }
            if (this.selectedUsers.indexOf(item.au_m_xuid) < 0 && item.is_allowed) {
                this.selectedUsers.push(item.au_m_xuid);
            }
        }
        this.getUsers().then(function () {
            _this.setUserItems();
            _this.countAllowed();
            _this.onCancel();
            _this.onCancelUser(0);
            _this.setCompRec();
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm' || (this.cols.length > 0 && this.cols[0].readonly)) {
            this.readonly = true;
        }
    };
    KtsMultiSelectPartnerUserComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#open') {
            this.onCancel();
            this.remodal.open();
        }
    };
    KtsMultiSelectPartnerUserComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    KtsMultiSelectPartnerUserComponent.prototype.getRetiree = function () {
        var _this = this;
        var url = '/v1/gen/au-profile-api';
        url += '?query={"predicateList":[{"name":"au_m.status","value":"2","operator":"eq"}]}';
        this.service.setBaseUrl(url);
        this.service.getRecord().subscribe(function (rec) {
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                _this.retirees.push(item.xuid);
            }
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.onChangeCompanyName = function (e) {
        this.companyName = e.target.value;
    };
    KtsMultiSelectPartnerUserComponent.prototype.onChange = function (e, key) {
        var _this = this;
        var pred = [];
        if (key === 'constClass') {
            this.constClassId = parseInt(e.target.value);
            this.constMiddleClassId = 0;
        }
        else if (key === 'constMiddleClass') {
            this.constMiddleClassId = parseInt(e.target.value);
        }
        else if (key === 'area') {
            this.areaId = parseInt(e.target.value);
        }
        if (this.constMiddleClassId) {
            pred.push('{"operator":"eq","name":"link_partner_company_m_middle_classification.construction_middle_classification.id","value":"' + this.constMiddleClassId + '"}');
        }
        else if (this.constClassId) {
            pred.push('{"operator":"eq","name":"link_partner_company_m_middle_classification.construction_middle_classification.construction_classification_m.id","value":"' + this.constClassId + '"}');
        }
        if (this.areaId) {
            pred.push('{"operator":"in","name":"area_ids","values":["' + this.areaId + '"]}');
        }
        if (this.companyName) {
            pred.push('{"operator":"like","name":"name","value":"' + this.companyName + '"}');
        }
        if (pred.length === 0) {
            this.targetIds = [];
            $(this.element).multiSelect('refresh');
            return;
        }
        this.service.setBaseUrl('/v1/gen/partner-company-m-service?query={"predicateList":[' + pred.join(',') + ']}');
        this.service.getRecord().subscribe(function (rec) {
            var targets = [];
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                targets.push(item.id);
            }
            _this.targetIds = targets;
            $(_this.element).multiSelect('refresh');
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.onCancel = function () {
        this.companyName = '';
        $(this.element).multiSelect('deselect_all');
        var select = [];
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            select.push(item.partner_company_m_id.toString());
        }
        $(this.element).multiSelect('select', select);
        this.select = select;
        this.constClassId = 0;
        this.constMiddleClassId = 0;
        this.areaId = 0;
        this.targetIds = [];
        $(this.element).multiSelect('refresh');
    };
    KtsMultiSelectPartnerUserComponent.prototype.onSubmit = function () {
        var _this = this;
        this.companyName = '';
        this.setItems();
        this.getUsers().then(function () {
            _this.setUserItems();
            _this.countAllowed();
            _this.addError();
            _this.setCompRec();
            _this.remodal.close();
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.setItems = function () {
        var _this = this;
        var items = JSOG.parse(JSON.stringify(this.items));
        for (var i = items.length - 1; i >= 0; i--) {
            if (typeof items[i].id === 'undefined') {
                items.splice(i, 1);
            }
            else {
                items[i].$type = "delete" /* Delete */;
            }
        }
        for (var _i = 0, _a = this.select; _i < _a.length; _i++) {
            var s = _a[_i];
            var rec = new List();
            for (var _b = 0, _c = this.recs; _b < _c.length; _b++) {
                var r = _c[_b];
                if (s === r.id.toString()) {
                    rec = r;
                    break;
                }
            }
            var add = true;
            for (var _d = 0, items_1 = items; _d < items_1.length; _d++) {
                var item = items_1[_d];
                if (item.partner_company_m_id === rec.id) {
                    add = false;
                    item.$type = "put" /* Put */;
                }
            }
            if (add) {
                items.push({
                    $type: "post" /* Post */,
                    partner_company_m_id: rec.id,
                    partner_company_name: rec.name,
                    count_allowed: 0,
                    count_not_allowed: 0,
                    unit_m_id: rec.unit_m_id
                });
            }
        }
        for (var _e = 0, items_2 = items; _e < items_2.length; _e++) {
            var item = items_2[_e];
            if (item.$type === "delete" /* Delete */) {
                item.count_allowed = 0;
                item.count_not_allowed = 0;
            }
        }
        var _loop_1 = function (i) {
            var item = items.find(function (item) { return item.unit_m_id === _this.showUsers[i].unit_m_id; });
            if (typeof item === 'undefined' || item.$type === "delete" /* Delete */) {
                var index = this_1.selectedUsers.indexOf(this_1.showUsers[i].au_m_xuid);
                if (index >= 0) {
                    this_1.selectedUsers.splice(index, 1);
                }
                this_1.showUsers.splice(i, 1);
            }
        };
        var this_1 = this;
        for (var i = this.showUsers.length - 1; i >= 0; i--) {
            _loop_1(i);
        }
        this.items = items;
    };
    KtsMultiSelectPartnerUserComponent.prototype.getUsers = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var partnerIds = [];
            for (var _i = 0, _a = _this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.$type === "delete" /* Delete */) {
                    continue;
                }
                partnerIds.push(item.partner_company_m_id);
            }
            var pred = '{"operator":"in","name":"au_m.unit_m.unit_m.partner_company_m.id","values":[' + partnerIds + ']}';
            var url = '/v1/gen/au-profile-partner-user-api?query={"predicateList":[' + pred + ']}';
            _this.service.setBaseUrl(url);
            _this.service.getRecord().subscribe(function (rec) {
                var _loop_2 = function (item) {
                    if (typeof _this.showUsers.find(function (show) { return show.au_m_xuid === item.au_m_xuid; }) === 'undefined') {
                        _this.showUsers.push({
                            au_m_xuid: item.au_m_xuid,
                            sei: item.sei,
                            mei: item.mei,
                            email: item.email,
                            unit_m_id: item.unit_m_id
                        });
                    }
                };
                for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                    var item = _a[_i];
                    _loop_2(item);
                }
                resolve();
            });
        });
    };
    KtsMultiSelectPartnerUserComponent.prototype.openModalUser = function (unit_m_id) {
        var _this = this;
        if (typeof this.showUsers.find(function (show) { return show.unit_m_id === unit_m_id; }) === 'undefined') {
            this.alertModalService.open({
                message: this.msgSnapshot['au.COMPONENT.KtsMultiSelectPartnerUserComponent.modal.no_user_company'],
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#noUser#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }],
                type: 'warn'
            });
            return;
        }
        this.targetUserIds = [];
        this.showUsers
            .filter(function (item) { return item.unit_m_id === unit_m_id; })
            .forEach(function (item) {
            _this.targetUserIds.push(item.au_m_xuid);
        });
        this.onCancelUser(unit_m_id);
        this.remodalUser.open();
    };
    KtsMultiSelectPartnerUserComponent.prototype.onCancelUser = function (unit_m_id) {
        $(this.elementUser).multiSelect('deselect_all');
        var selectedUsers = [];
        for (var _i = 0, _a = this.userItems.filter(function (i) { return i.is_allowed; }); _i < _a.length; _i++) {
            var item = _a[_i];
            if (item.$type !== "delete" /* Delete */) {
                selectedUsers.push(item.au_m_xuid);
            }
        }
        this.selectedUsers = selectedUsers;
        if (unit_m_id > 0) {
            var selected_1 = [];
            var showUsr = this.showUsers.filter(function (show) { return show.unit_m_id === unit_m_id; });
            showUsr.forEach(function (show) {
                if (selectedUsers.indexOf(show.au_m_xuid) >= 0) {
                    selected_1.push(show.au_m_xuid);
                }
            });
            selectedUsers = selected_1;
        }
        $(this.elementUser).multiSelect('select', selectedUsers);
        $(this.elementUser).multiSelect('refresh');
    };
    KtsMultiSelectPartnerUserComponent.prototype.onSubmitUser = function () {
        this.setUserItems();
        this.countAllowed();
        this.setCompRec();
        this.remodalUser.close();
    };
    KtsMultiSelectPartnerUserComponent.prototype.setUserItems = function () {
        var userItems = JSOG.parse(JSON.stringify(this.userItems));
        for (var i = userItems.length - 1; i >= 0; i--) {
            if (typeof userItems[i].id === 'undefined') {
                userItems.splice(i, 1);
            }
            else {
                userItems[i].$type = "delete" /* Delete */;
            }
        }
        var _loop_3 = function (selectedUser) {
            var show = this_2.showUsers.find(function (x) { return x.au_m_xuid === selectedUser; }) || new ListUser();
            var add = true;
            for (var _i = 0, userItems_1 = userItems; _i < userItems_1.length; _i++) {
                var item = userItems_1[_i];
                if (item.au_m_xuid === show.au_m_xuid) {
                    add = false;
                    item.$type = "put" /* Put */;
                }
            }
            if (add) {
                userItems.push({
                    $type: "post" /* Post */,
                    au_m_xuid: show.au_m_xuid,
                    sei: show.sei,
                    mei: show.mei,
                    email: show.email,
                    unit_m_id: show.unit_m_id,
                    is_allowed: true
                });
            }
        };
        var this_2 = this;
        for (var _i = 0, _a = this.selectedUsers; _i < _a.length; _i++) {
            var selectedUser = _a[_i];
            _loop_3(selectedUser);
        }
        this.userItems = userItems;
    };
    KtsMultiSelectPartnerUserComponent.prototype.countAllowed = function () {
        var _loop_4 = function (item) {
            if (item.$type === "delete" /* Delete */) {
                return "continue";
            }
            if (this_3.showUsers.filter(function (show) { return show.unit_m_id === item.unit_m_id; }).length === 0) {
                item.count_allowed = 0;
                item.count_not_allowed = 0;
                return "continue";
            }
            var count = 0;
            for (var _i = 0, _a = this_3.showUsers.filter(function (show) { return show.unit_m_id === item.unit_m_id; }); _i < _a.length; _i++) {
                var user = _a[_i];
                if (this_3.selectedUsers.indexOf(user.au_m_xuid) >= 0) {
                    count++;
                }
            }
            item.count_allowed = count;
            item.count_not_allowed = this_3.showUsers.filter(function (show) { return show.unit_m_id === item.unit_m_id; }).length - count;
        };
        var this_3 = this;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            _loop_4(item);
        }
    };
    KtsMultiSelectPartnerUserComponent.prototype.setCompRec = function () {
        var data = {};
        var items = JSOG.parse(JSON.stringify(this.userItems));
        if (Object.keys(this.addRec).length > 0) {
            for (var _i = 0, items_3 = items; _i < items_3.length; _i++) {
                var item = items_3[_i];
                Object.assign(item, this.addRec);
            }
        }
        items = items.filter(function (item) { return (item.$type !== "post" /* Post */ || item.is_allowed); })
            .map(function (item) {
            if (item.$type === "put" /* Put */ && !item.is_allowed) {
                item.$type = "delete" /* Delete */;
            }
            delete item.unit_m_id;
            delete item.sei;
            delete item.mei;
            return item;
        });
        data[this.cols[0].key] = items;
        this.action.setCompRec(this.componentName + 'User', data);
        var companyData = {};
        var companyItems = JSOG.parse(JSON.stringify(this.items));
        for (var _a = 0, companyItems_1 = companyItems; _a < companyItems_1.length; _a++) {
            var item = companyItems_1[_a];
            delete item.count_allowed;
            delete item.count_not_allowed;
            delete item.unit_m_id;
        }
        companyData[this.cols[0].key] = companyItems;
        this.action.setCompRec(this.componentName, companyData);
    };
    KtsMultiSelectPartnerUserComponent.prototype.addError = function () {
        if (this.cols[0].required && this.dir) {
            var items = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.$type === "delete" /* Delete */) {
                    continue;
                }
                items.push(item);
            }
            var errFlg = (items.length === 0 ? true : false);
            this.dir.addRequiredError(errFlg, this.msgSnapshot['ColumnComponent.error.required']);
            this.validService.afterValidation();
        }
    };
    KtsMultiSelectPartnerUserComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
        if ($(this.modalUser).parent().hasClass('remodal-wrapper')) {
            this.remodalUser.destroy();
        }
    };
    KtsMultiSelectPartnerUserComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-multiselect-partner-user',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'form'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n      </dl>\n    </div>\n  </div>\n  <div addrowDir></div>\n  <div class=\"row -mt-1\" *ngIf=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <btn\n          [componentName]=\"componentName + '#Button'\"\n          [component]=\"{\n            params: {\n              buttons: [{\n                type: 'button',\n                event: componentName + '#open',\n                caption: (msg | async)['Button_select']\n              }]\n            }\n          }\"></btn>\n    </div>\n  </div>\n  <div class=\"row\" [class.-mt-1]=\"!readonly\">\n    <div class=\"col-sm-12\">\n      <div class=\"tableWrapper\" id=\"{{ componentName + '#List' }}\">\n        <table class=\"tableWrapper_table\">\n          <thead>\n          <tr data-href=\"#\">\n            <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.label.partner_company_name'] }}</a></th>\n            <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerUserComponent.label.allowed'] }}</a></th>\n            <th><a class=\"-fixed\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerUserComponent.label.not_allowed'] }}</a></th>\n            <th></th>\n          </tr>\n          </thead>\n          <tbody>\n          <ng-template ngFor let-item [ngForOf]=\"items\">\n            <tr *ngIf=\"item.$type !== 'delete'\" data-href=\"#\">\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"item.partner_company_name\"></column-formlabel>\n              </td>\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"item.count_allowed\"></column-formlabel>\n              </td>\n              <td>\n                <column-formlabel [col]=\"{}\" [val]=\"item.count_not_allowed\"></column-formlabel>\n              </td>\n              <td>\n                <button *ngIf=\"!readonly\" class=\"btn btn-sm\" type=\"button\" (click)=\"openModalUser(item.unit_m_id)\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerUserComponent.button.setting'] }}</button>\n              </td>\n            </tr>\n          </ng-template>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n\n  <!-- remodal -->\n  <div class=\"remodal\" id=\"{{ componentName + '#MultiSelect' }}\" #remodal>\n    <div class=\"remodal_whitebg\">\n      <p *ngIf=\"component.title\" class=\"sectionHeading\">{{ component.title }}</p>\n      <div class=\"ms-container_divisionWrapper\">\n        <div class=\"row -mb-1\">\n          <div class=\"col-sm-6\"></div>\n          <div class=\"col-sm-4\">\n            <input type=\"text\" class=\"formInputText\" placeholder=\"{{(msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.label.partner_company_name']}}\" [value]=\"companyName\" (change)=\"onChangeCompanyName($event)\">\n          </div>\n          <div class=\"col-sm-2\">\n            <item-btn [key]=\"'btn'\" [btn]=\"{\n              type: 'button',\n              event: componentName + '#search',\n              caption: (msg | async)['au.COMPONENT.KtsMultiSelectComponent.label.search']\n            }\" (click)=\"onChange($event, 'companyName')\"></item-btn>\n          </div>\n        </div>\n        <p class=\"ms-container_division\">\n          <select (change)=\"onChange($event,'constClass')\">\n            <option value=\"0\" [selected]=\"constClassId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.constructionClassification'] }}</option>\n            <option *ngFor=\"let option of constClass\" [value]=\"option.code\" [selected]=\"constClassId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n          <select (change)=\"onChange($event, 'constMiddleClass')\">\n            <option value=\"0\" [selected]=\"constMiddleClassId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.constructionMiddleClassification'] }}</option>\n            <option *ngFor=\"let option of constMiddleClass[constClassId]\" [value]=\"option.code\" [selected]=\"constMiddleClassId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n        <p class=\"ms-container_division\">\n          <select (change)=\"onChange($event, 'area')\">\n            <option value=\"0\" [selected]=\"areaId === 0\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerCompanyComponent.select.area'] }}</option>\n            <option *ngFor=\"let option of area\" [value]=\"option.code\" [selected]=\"areaId.toString() === option.code\">{{ option.display }}</option>\n          </select>\n        </p>\n      </div>\n      <div class=\"ms-containerWrapper\">\n        <select multiple=\"multiple\" #multiSelect>\n          <option *ngFor=\"let option of recs\" [value]=\"option.id\" [attr.data-id]=\"option.id\" #multiSelectOptions>{{ option.name }}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"remodal_btns\">\n      <ul class=\"remodal_btns_group\">\n        <li>\n          <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmit()\">{{ (msg | async)['au.COMPONENTS.modal.button.decide'] }}</button>\n        </li>\n        <li>\n          <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onCancel()\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- /remodal -->\n\n  <!-- remodal -->\n  <div class=\"remodal\" id=\"{{ componentName + '#MultiSelectUser' }}\" #remodalUser>\n    <div class=\"remodal_whitebg\">\n      <p *ngIf=\"excludeHq\" class=\"sectionHeading\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerUserComponent.label.agency_account'] }}</p>\n      <p *ngIf=\"!excludeHq\" class=\"sectionHeading\">{{ (msg | async)['au.COMPONENT.KtsMultiSelectPartnerUserComponent.label.partner_account'] }}</p>\n      <div class=\"ms-containerWrapper\">\n        <select multiple=\"multiple\" #multiSelectUser>\n          <option *ngFor=\"let option of showUsers\" [value]=\"option.au_m_xuid\" [attr.data-id]=\"option.au_m_xuid\" #multiSelectOptionsUser>{{ option.sei }} {{ option.mei }} / {{ option.email }}</option>\n        </select>\n      </div>\n    </div>\n    <div class=\"remodal_btns\">\n      <ul class=\"remodal_btns_group\">\n        <li>\n          <button type=\"submit\" class=\"remodal_btns_group-ok\" (click)=\"onSubmitUser()\">{{ (msg | async)['au.COMPONENTS.modal.button.decide'] }}</button>\n        </li>\n        <li>\n          <button data-remodal-action=\"cancel\" type=\"reset\" class=\"remodal_btns_group-cancel\" (click)=\"onCancelUser(0)\">{{ (msg | async)['au.COMPONENTS.modal.button.close'] }}</button>\n        </li>\n      </ul>\n    </div>\n  </div>\n  <!-- /remodal -->\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsMultiSelectPartnerUserComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsMultiSelectPartnerUserService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    KtsMultiSelectPartnerUserComponent.propDecorators = {
        modalSubmit: [{ type: Output }],
        remodalElement: [{ type: ViewChild, args: ['remodal',] }],
        remodalUserElement: [{ type: ViewChild, args: ['remodalUser',] }],
        multiSelectElement: [{ type: ViewChild, args: ['multiSelect',] }],
        multiSelectElementUser: [{ type: ViewChild, args: ['multiSelectUser',] }],
        multiSelectOptions: [{ type: ViewChildren, args: ['multiSelectOptions',] }],
        multiSelectOptionsUser: [{ type: ViewChildren, args: ['multiSelectOptionsUser',] }],
        dir: [{ type: ViewChild, args: [AddRowDirective,] }]
    };
    return KtsMultiSelectPartnerUserComponent;
}(ContentBaseComponent));
export { KtsMultiSelectPartnerUserComponent };
//# sourceMappingURL=multiselect-partner-user.component.js.map